export default class CCActivity {
    ccActivityId: number;
    activityName: string;
    organizationName: string;
    completedDate: string
    isSa: boolean;
    isPipClinical: boolean;
    isPipFeedback: boolean;
    isPatientSafety: boolean;
    cmeCredits: number;
    saCredits: number;
    isEditing: boolean;
    isNew: boolean;
}